<h2>Promotion</h2>
<app-promotion [userInfos]="userInfos" [promotionData]="dataSource" [productData]="products" [promoterData]="promoters" [platformInfos]="platformInfos"></app-promotion>
